var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPublic)?_c('div',{staticClass:"side-menu-card public font-weight-bold",on:{"click":_vm.goPublicClass}},[_c('span',[_vm._v("Public Class")]),_c('div',{staticClass:"public-menu"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }